import { takeLatest, takeEvery, call, put } from 'redux-saga/effects';
import _ from 'lodash';
import {
  FETCH_CUSTOMERS, fetchCustomersSuccess, fetchCustomersFailed, fetchingCustomers,
  FETCH_CUSTOMER, fetchCustomerSuccess, fetchingCustomer,
} from '../actions/customers';
import { fetchDoc, fetchCol } from './helper';
import { showDialog } from '../actions/dialogs';

import { saveCustomerRoutine, removeCustomerRoutine } from '../routines';

import { id, toArray } from '../utils/helper';
import { firestore, getTenantPath } from '../utils/firebase';

function enrich(customer) {
  return fetchDoc(getTenantPath(`/employees/${customer.customerManagerId}`))
    .then((customerManager) => {
      if (customer.contacts) {
        customer.primaryContact = customer.contacts[customer.primaryContactId];
      }

      customer.customerManager = customerManager;

      return customer;
    });
}

function fetchCustomers() {
  return fetchCol(getTenantPath('/customers'))
    .then((customers) => {
      return Promise.all(_.values(customers).filter((customer) => !customer.deleted).map(enrich))
        .then(() => customers);
    });
}

function fetchCustomer(id) {
  if (!id || id === 'create') {
    return {};
  }

  console.log('fetchCustomer', 'id', id);

  return fetchDoc(getTenantPath(`/customers/${id}`))
    .then((customer) => {
      if (customer.customerManagerId) {
        return enrich(customer);
      }

      return customer;
    });
}

function* fetchCustomersSaga() {
  try {
    yield put(fetchingCustomers());
    const customers = yield call(fetchCustomers);
    yield put(fetchCustomersSuccess(toArray(customers).filter(((customer) => !customer.deleted))));
  } catch (e) {
    console.log('e', e);
    yield put(fetchCustomersFailed(e));
  }
}

function* watchFetchCustomersSaga() {
  yield takeLatest(FETCH_CUSTOMERS, fetchCustomersSaga);
}

function* fetchCustomerSaga(action) {
  try {
    yield put(fetchingCustomer(action.customerId));
    const customer = yield call(fetchCustomer, action.customerId);
    yield put(fetchCustomerSuccess(customer));
  } catch (e) {
    console.error('e', e);
    yield put(fetchCustomersFailed(action.customerId, e));
  }
}

function* watchFetchCustomerSaga() {
  yield takeLatest(FETCH_CUSTOMER, fetchCustomerSaga);
}

function* watchSaveCustomerSaga() {
  // run fetchDataFromServer on every trigger action
  yield takeLatest(saveCustomerRoutine.TRIGGER, saveCustomerSaga);
}

function saveCustomer(data) {
  const customer = _.omit(_.assign({ id: id() }, data), ['customerManager']);
  if (!customer.primaryContactId && customer.contacts && _.keys(customer.contacts).length > 0) {
    customer.primaryContactId = _.keys(customer.contacts)[0];
  }

  console.log('saveCustomer', customer);
  return firestore.doc(getTenantPath(`customers/${customer.id}`)) // TODO remove hard coded
    .set(customer, { merge: true })
    .then(() => customer)
    .then(enrich);
}

function* saveCustomerSaga(action) {
  console.log('cust2', action.payload.toJS());
  const customer = _.pickBy(action.payload.toJS(), (value, key) => value);
  console.log('customer', customer);
  try {
    // trigger request action
    yield put(saveCustomerRoutine.request(customer));
    // perform request to '/some_url' to fetch some data
    const response = yield call(saveCustomer, customer);
    // if request successfully finished
    yield put(saveCustomerRoutine.success({ success: true, customer: response, }));
  } catch (error) {
    console.error('saveCustomerSaga', error);
    // if request failed
    yield put(saveCustomerRoutine.failure({ success: false }));
  } finally {
    // trigger fulfill action
    yield put(saveCustomerRoutine.fulfill());
  }
}

function* watchRemoveCustomerSaga() {
  // run fetchDataFromServer on every trigger action
  yield takeEvery(removeCustomerRoutine.TRIGGER, removeCustomerSaga);
}

function removeCustomer(customer) {
  return firestore.doc(getTenantPath(`customers/${customer.id}`))
    .update({ deleted: { at: new Date().toISOString() } })
    .then(() => customer);
}

function* removeCustomerSaga(action) {
  const customer = action.payload;
  try {
    // trigger request action
    yield put(removeCustomerRoutine.request(customer));
    // perform request to '/some_url' to fetch some data
    yield call(removeCustomer, customer);
    // if request successfully finished
    yield put(removeCustomerRoutine.success({ success: true, customer, }));
  } catch (err) {
    console.error(err);
    // if request failed
    yield put(removeCustomerRoutine.failure({ success: false }));
    yield put(showDialog('alert', { title: 'Unable to remove customer', message: err.message, type: 'severe' }));
  } finally {
    // trigger fulfill action
    yield put(removeCustomerRoutine.fulfill());
  }
}

export {
  fetchCustomersSaga,
  watchFetchCustomersSaga,
  fetchCustomerSaga,
  watchFetchCustomerSaga,
  watchSaveCustomerSaga,
  watchRemoveCustomerSaga,
};



// WEBPACK FOOTER //
// ./src/sagas/customers.js